module.exports = __webpack_public_path__ + "static/media/left-arrow.6fd934a7.svg";